import React from 'react';
import { useField } from 'formik';
import { KoobInputLabel, KoobInputText } from '@koob/ui';

export interface FolderFormTextFieldProps {
  name: string;
  /** Left out when the modal lays out its own label. */
  label?: string;
  required?: boolean;
  testId?: string;
}

/** Formik-bound text input of the client folder modals (KD-3842). */
export default function FolderFormTextField({
  name,
  label,
  required = false,
  testId,
}: FolderFormTextFieldProps) {
  const [field, meta] = useField<string | null>(name);
  const hasError = Boolean(meta.touched && meta.error);

  return (
    <div className="flex flex-col gap-1.5">
      {label && <KoobInputLabel label={label} required={required} />}
      <KoobInputText
        {...field}
        value={field.value ?? ''}
        error={hasError}
        data-testid={testId}
      />
      {hasError && <span className="text-xs text-red-500">{meta.error}</span>}
    </div>
  );
}
